// extracted by css-extract-rspack-plugin
export default {"root":"uYEW7o","discount-row":"nEScHJ","discountRow":"nEScHJ","past-discounts-bar":"_mjpF3","pastDiscountsBar":"_mjpF3"};